import React, { Component } from 'react'
import { Modal } from 'components/elements'
import { Subscribe } from 'unstated'
import { withRouter } from 'react-router-dom'
import LoginForm from '../login/loginForm'
import SignUpWizard from './signUpWizard.js' //Change this variable name later.
import AppContainer from '../../context/AppContainer'
import { trackSignUpWizardClosed } from '../../elements/tracking/signupTracking.js'
class LoginSignupModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      viewType: this.props.viewType,
      modalOpen: this.props.modalOpen,
      showViewSwitcher: true,
      triggeredFrom: this.props.triggeredFrom,
    }
  }

  handleLogin = () => {
    this.props.onClose()
    if (this.props.location.pathname === '/list-your-motorcycle') {
      this.props.history.push('/list/motorcycle')
    }
  }

  handleClose = () => {
    trackSignUpWizardClosed({ screen: this.props.modalType })
    this.props.onClose()
  }

  handleSignUpSuccess = () => {
    // alert('You are signed up, and we would take you to the search page..')
    this.props.onClose()
  }

  changeModalView = (newView, updateAuthState) => {
    updateAuthState(newView)
  }

  hideContextMenu = () => {
    this.setState({
      showViewSwitcher: false,
    })
  }

  render() {
    const { modalOpen, triggeredFrom } = this.props

    const { showViewSwitcher } = this.state
    return (
      <Subscribe to={[AppContainer]}>
        {(auth) => {
          return (
            <Modal
              show={modalOpen}
              onClose={this.handleClose}
              closeOnBlur={true}
              closeOnEsc={true}
              size="tiny"
              closeClass={'is-medium'}
            >
              {auth.state.modalViewType === 'login' && (
                <div>
                  <LoginForm
                    container="modal"
                    hideShadow={true}
                    onSuccess={() => this.handleLogin()}
                    parentDescription="Login Sign Up Modal"
                  />
                  <div className="has-text-centered mt-3">
                    <p>No Twisted Road Account?</p>
                    <button
                      className="button is-text has-text-primary"
                      type="button"
                      onClick={() =>
                        this.changeModalView(
                          'signup',
                          auth.switchLoginModalView
                        )
                      }
                    >
                      Sign Up Now
                    </button>
                  </div>
                </div>
              )}
              {auth.state.modalViewType === 'signup' && (
                <div>
                  <SignUpWizard
                    container="modal"
                    auth={auth}
                    closeModal={this.handleClose}
                    onSuccess={this.handleSignUpSuccess}
                    afterBasicInfo={this.hideContextMenu}
                    triggeredFrom={this.state.triggeredFrom}
                  />
                  {showViewSwitcher && (
                    <div className="has-text-centered mt-3">
                      <p>Already signed up?</p>
                      <button
                        type="button"
                        className="button is-text has-text-primary"
                        onClick={() =>
                          this.changeModalView(
                            'login',
                            auth.switchLoginModalView
                          )
                        }
                      >
                        Login
                      </button>
                    </div>
                  )}
                </div>
              )}
            </Modal>
          )
        }}
      </Subscribe>
    )
  }
}
export default withRouter(LoginSignupModal)

LoginSignupModal.defaultProps = {
  viewType: 'login',
  modalOpen: false,
  onClose: null,
  triggeredFrom: null,
  //onLogin : false
}
